"use client"

import { UserMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserMinusIcon = component(Icon)({ as: UserMinus })
